import ajax from '@/utils/ajax.js'

// 获取站内信状态
export const getStationStatus = async () => {
  return await ajax.post('/webapi/component-tools-message/v1/station/todo')
}

// 获取未读/待办
export const searchStationSummaryList = async () => {
  return await ajax.post('/webapi/component-tools-message/v1/station/summary')
}

// 去完成任务
export const stationTaskGo = async (data) => {
  const res = await ajax.export('/webapi/component-tools-message/v1/station/action', data)
  return res
}

// 用户站内信全部已读
export const stationAllRead = async () => {
  const res = await ajax.post('/webapi/component-tools-message/v1/station/notice/read-all')
  return res
}

export const stationRead = async (data) => {
  return await ajax.post('/webapi/component-tools-message/v1/station/notice/read', { data })
}
